import { api } from "../api";

export const getChecklist = async (projectId: number) => {
  let url = `/checklist/projectId/${projectId}`;
  return await api.get(url);
};

export const getTemplateChecklists = async () => {
  let url = `/checklist/template`;
  return await api.get(url);
};

type CheckList = {
  id: number;
  projectId: number;
  title: string;
  isTemplate: boolean;
  createdAt: Date;
};

export type CreateCheckListBody = Omit<CheckList, "id, createdAt">;

export const createChecklist = async (body: CreateCheckListBody) => {
  let url = `/checklist`;
  return await api.post(url, body);
};

export type DuplicateCheckListBody = {
  projectId: number;
  checklistId: number;
};

export const duplicateChecklist = async (body: DuplicateCheckListBody) => {
  let url = `/checklist/duplicate`;
  return await api.post(url, body);
};

export type UpdateCheckListBody = Omit<CheckList, "createdAt, projectId">;

export const updateChecklist = async (body: UpdateCheckListBody) => {
  let url = `/checklist`;
  return await api.put(url, body);
};

export const deleteChecklist = async (checklistId: number) => {
  let url = `/checklist/${checklistId}`;
  return await api.delete(url);
};
